import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
//import AvatarCropper from "react-avatar-cropper";
import FileRead from "./FileRead";
import * as EmployeeActions from "../../domain/employee/employeeActions";
class ImageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      croppedImg: "",
      file: "",
      img: "",
      ImageId: props.ImageId
    };
    this.getInitialState = this.getInitialState.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
    this.srcToFile = this.srcToFile.bind(this);
    this.handleRequestHide = this.handleRequestHide.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.ImageUrl === "" ||
      nextProps.ImageUrl === undefined ||
      nextProps.ImageUrl === null
    ) {
      this.setState({
        croppedImg: "https://image.ibb.co/mBR81v/defImage.png"
      });
    } else {
      this.setState({
        croppedImg: nextProps.ImageUrl
      });
    }
  }

  getInitialState() {
    return {
      cropperOpen: false,
      img: null
    };
  }
  handleFileChange(file, dataURI) {
    this.setState({
      img: dataURI,
      file: file,
      croppedImg: this.state.croppedImg,
      cropperOpen: true
    });
  }

  srcToFile(src, fileName, mimeType) {
    return fetch(src)
      .then(function(res) {
        return res.arrayBuffer();
      })
      .then(function(buf) {
        return new File([buf], fileName, { type: mimeType });
      });
  }

  handleCrop(dataURI) {
    const { EmployeeActions } = this.props;
    this.srcToFile(
      dataURI,
      this.state.file.name,
      this.state.file.type
    ).then(function(file) {
      EmployeeActions.profileImageSaveBtn(true);
      EmployeeActions.setFileDetail(file);
    });

    this.setState({
      cropperOpen: false,
      img: null,
      croppedImg: dataURI
    });
  }
  handleRequestHide() {
    this.setState({
      cropperOpen: false
    });
  }
  render() {
    return (
      <div className="fl mr15">
        <div className="avatar-photo">
          <FileRead handleFileChange={this.handleFileChange} />
          <div className="avatar-edit">
            <span />
            <i className="fa fa-camera" />
          </div>
          <img src={this.state.croppedImg} width="145" alt="" />
        </div>
        {this.state.cropperOpen && (null

        )}
      </div>
    );
  }
}
const mapStateToProps = ({ employeeReducer }) => {
  const { ImageUrl } = employeeReducer;
  return {
    ImageUrl
  };
};
const mapDispatchToProps = dispatch => {
  return {
    EmployeeActions: bindActionCreators(EmployeeActions, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ImageComponent);
          // <AvatarCropper
          //   onRequestHide={this.handleRequestHide}
          //   cropperOpen={this.state.cropperOpen}
          //   onCrop={this.handleCrop}
          //   image={this.state.img}
          //   width={250}
          //   height={250}
          // />